<template>
  <div class="ratingWidget__container">
    <div class="ratingWidget__content-container" :id="ratingId">
      <div class="flip-cardcontainer">
        <p class="flip-cardcontainer_averageRating">
          <span v-for="(heart, index) in hearts">
            <img :src="heart" alt="" />
          </span>
        </p>
        <div class="flip-cardoverlay" :class="{ focused: focused }">
          <div class="flip-cardtext text-center">
            <div
              class="rate"
              @keyup.enter="ratingPicked($event)"
              >
              <input
                type="radio"
                id="star5"
                name="rate"
                value="5"
                data-rating="5"
                :aria-label="`${getAriaLabelDetails(5)}`"
                :tabindex="getAriaLabelDetails(5) !== '' ? 0 : -1"
                v-model.number="picked"
                @focusin="overlayFocused()"
                @focusout="handleFocusout($event)"
                @click="ratingPicked($event)"
              />
              <label for="star5" :title="fiveStarRating" tabindex="-1">rate 5 stars</label>
              <input
                type="radio"
                id="star4"
                name="rate"
                value="4"
                data-rating="4"
                :aria-label="`${getAriaLabelDetails(4)}`"
                :tabindex="getAriaLabelDetails(4) !== '' ? 0 : -1"
                v-model.number="picked"
                @focusin="overlayFocused()"
                @focusout="handleFocusout($event)"
                @click="ratingPicked($event)"
              />
              <label for="star4" :title="fourStarRating" tabindex="-1">rate 4 stars</label>
              <input
                type="radio"
                id="star3"
                name="rate"
                value="3"
                data-rating="3"
                :aria-label="`${getAriaLabelDetails(3)}`"
                :tabindex="getAriaLabelDetails(3) !== '' ? 0 : -1"
                v-model.number="picked"
                @focusin="overlayFocused()"
                @focusout="handleFocusout($event)"
                @click="ratingPicked($event)"
              />
              <label for="star3" :title="threeStarRating" tabindex="-1">rate 3 stars</label>
              <input
                type="radio"
                id="star2"
                name="rate"
                value="2"
                data-rating="2"
                :aria-label="`${getAriaLabelDetails(2)}`"
                :tabindex="getAriaLabelDetails(2) !== '' ? 0 : -1"
                v-model.number="picked"
                @focusin="overlayFocused()"
                @focusout="handleFocusout($event)"
                @click="ratingPicked($event)"
              />
              <label for="star2" :title="twoStarRating" tabindex="-1">rate 2 stars</label>
              <input
                type="radio"
                id="star1"
                name="rate"
                value="1"
                data-rating="1"
                :aria-label="`${getAriaLabelDetails(1)}`"
                :tabindex="getAriaLabelDetails(1) !== '' ? 0 : -1"
                v-model.number="picked"
                @focusin="overlayFocused()"
                @focusout="handleFocusout($event)"
                @click="ratingPicked($event)"
              />
              <label for="star1" :title="oneStarRating" tabindex="-1">rate 1 star</label>
            </div>
          </div>
          <div class="picked-rating">
            <!-- <p role="alert" v-if="hasSubmitted == false">
              {{ picked }} star rating
            </p> -->
            <p role="alert" v-if="hasSubmitted == true">
              You rated {{ picked }} stars
            </p>
            <p class="errorMessage" role="alert" v-if="errorFound == true">
              {{ voteErrorMessage }}
            </p>
            <transition name="fade">
              <p class="votedAlready" role="alert" v-if="votedAlready">
                You've already voted once
              </p>
            </transition>
          </div>
        </div>
      </div>
      <div class="average">
        <span v-if="ratingTotal >= 1">
          <span class="averageRating"
            >{{ avgRating.toFixed(1) }} out of 5 stars</span
          >
          | {{ ratingTotal }} ratings
        </span>
        <span v-else>{{ rateMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import idMixin from "@/mixins/aha-id";
import axios from "axios";
import { Cookie } from "@/utils/aha-cookie";

export default {
  mixins: [idMixin],
  props: {
    avgRating: Number,
    total: Number,
    avgRatingId: Number,
    avgRatingPageId: String,
    voteErrorMessage: String,
    rateMessage: String,
    endpoint: String,
    oneStarRating: String,
    twoStarRating: String,
    threeStarRating: String,
    fourStarRating: String,
    fiveStarRating: String,
    recipe_ID: String,
    name: String,
  },
  data() {
    return {
      picked: 0,
      heartsRefs: {
        full: "/assets/icons/aha-heart.svg", //1 - 0.24 & 0.75-1
        half: "/assets/icons/aha-heart-half.svg", //0.25 - 0.74
        empty: "/assets/icons/aha-heart-empty.svg", //0 stars
      },
      hearts: [],
      focused: false,
      hasSubmitted: false,
      votedAlready: false,
      errorFound: false,
      ratingTotal: this.total,
      cookiePicked: "CookiePicked",
      cookieName: "starRatingWidget",
    };
  },
  mounted() {
    this.getHearts();
    if (Cookie.cookieExist(this.cookieName + this.avgRatingPageId)) {
      //logic to display uses rating
      this.ratingTotal = Cookie.getCookieValue(
        this.cookieName + this.avgRatingPageId
      );
      this.hasSubmitted = true  
      this.focused = true
      //this.disableRB();
    }

    if (Cookie.cookieExist(this.cookiePicked + this.avgRatingPageId)) {
      //logic to display uses rating
      this.picked = Cookie.getCookieValue(this.cookiePicked + this.avgRatingPageId);
    }
  },
  methods: {
    getHearts() {
      // Empties - default
      for (let i = 0; i < 5; i++) {
        this.hearts.push(this.heartsRefs.empty);
      }

      // Whole hearts
      let fullHearts = Math.floor(this.avgRating);
      for (let f = 0; f < fullHearts; f++) {
        this.hearts[f] = this.heartsRefs.full;
      }

      // Halves - decimal
      let halfHeart = Number(this.avgRating % 1);

      // Logic for half or not because images can be full, half or empty
      switch (true) {
      case halfHeart > 0.25 && halfHeart < 0.74:
      this.hearts[fullHearts] = this.heartsRefs.half;
      break;
      case halfHeart >= 0.75:
      this.hearts[fullHearts] = this.heartsRefs.full;
      break;
      default:
      return;
      }
    },
    handleFocusout (event) {
      if (event.relatedTarget && event.relatedTarget.name !== 'rate' && !this.hasSubmitted && !this.ratingTotal) {
        event.target.checked = event.target.checked && false;
      } else if (!this.hasSubmitted && this.ratingTotal) {
        event.target.checked = event.target.checked && false;
        var overlay = document.getElementsByClassName("flip-cardoverlay");
        overlay[0].classList.remove("focused");
      }
    },
    ratingPicked(event) {
      const that = this;
      var data = event.target.value;

      if (that.hasSubmitted) {
        if (event.clientX !== 0) {
          that.votedAlready = true;
          that.focused = true;
          setTimeout(
            function () {
            this.fadeAway();
            }.bind(this),
            3000
          );
        }
        event.preventDefault();
      } else if (event.clientX === 0) {
        return false;
      } else {
          axios
          .post(this.endpoint, {
            rating: data,
          })
          .then(function (response) {
            if (response.status == 200 || response.status == 201) {
              that.hasSubmitted = true;
              that.votedAlready = false;

              //increase rating
              that.ratingTotal++;

              Cookie.setCookie(
              that.cookieName + that.avgRatingPageId,
              that.ratingTotal
              );
              Cookie.setCookie(
              that.cookiePicked + that.avgRatingPageId,
              that.picked
              );              
            }
          })
          .catch(function (error) {
            that.errorFound = true;
          });
      }
    },
    fadeAway() {
      this.votedAlready = false;
    },
    overlayFocused() {
      var overlay = document.getElementsByClassName("flip-cardoverlay");
      var radios = document.querySelectorAll('input[name="rate"]:focus');
      if (radios.length == 1) {
        overlay[0].classList.add("focused");
      }
    },
    disableRB() {
      var radios = document.querySelectorAll(
      'input[name="rate"]:not(:checked)'
      );

      for (var i = 0; i < radios.length; i++) {
        radios[i].disabled = true;
      }
    },
    getAriaLabelDetails (item) {
      let labelName = '';
      var radios = document.querySelectorAll('input[name="rate"]:focus');
      if (radios.length && !this.hasSubmitted) {
        var currentAriaLabel = document.querySelectorAll(`[data-rating="${item}"]`);
        labelName = (currentAriaLabel[0].getAttribute("aria-label"));
      } else {
        if (this.ratingTotal >= 1 && (+this.picked === +item || (+this.picked === 0 && +item === 5))) {
          labelName = `${this.name} rated ${this.avgRating.toFixed(1)} out of 5 star for ${this.ratingTotal} ratings, ${this.hasSubmitted ? `You rated ${this.picked} star` : 'Rate this item (5 is the highest)'}, grouping, ${item} star`;
        } else if (+this.picked === 0 && +item === 5) {
          labelName = `${this.name} rate this item (5 is the highest), grouping, ${item} star`;
        }
      }
      return labelName;
    }
  },
  watch: {},
  computed: {
    ratingId: function () {
      return this.safeId("_AHA_rating_");
    },
  },
};
</script>

<style scoped>
.c-hero-card__action {
  overflow: hidden;
}

.rate {
  float: left;
  height: 26px;
  padding: 0 0 0 10px;
  margin-bottom: 0;
}

.rate label {
  margin-bottom: 0;
  margin: 0 1px;
}

.rate:not(:checked) > input {
  position: absolute;
  left: -9999px;
}

.rate:not(:checked) > label {
  float: right;
  width: 1em;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 27px;
  color: #fff;
}

.rate:checked > label {
  float: right;
  width: 1em;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 27px;
  color: #fff;
}

.rate:not(:checked) > label:before {
  content: url(../assets/icons/aha-heart-empty.svg);
  position: relative;
  bottom: 2px;
}

.rate > input:checked ~ label {
  content: url(../assets/icons/aha-heart.svg);
}

.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label,
.rate > input:checked + label:hover,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > input:checked + label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
  content: url(../assets/icons/aha-heart.svg);
}

.flip-cardcontainer {
  position: relative;
  width: 150px;
  margin-right: 5px;
}

.flip-cardimage {
  display: block;
  width: 100%;
  height: auto;
}

.flip-cardoverlay {
  position: absolute;
  bottom: 1px;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: #fff;
}

.flip-cardcontainer:hover .flip-cardoverlay,
.flip-cardoverlay.focused {
  opacity: 1;
}

.flip-cardtext {
  color: #000;
  font-size: 20px;
  position: relative;
  top: 0px;
  left: 68px;
  width: 155px;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

.flip-cardcontainer_averageRating {
  margin-bottom: 0;
}

.flip-cardcontainer_averageRating img {
  margin: 0 1px;
}

.average {
  position: relative;
  top: 3px;
}

.picked-rating {
  width: 150px;
  background-color: #fff;
  position: relative;
  top: 28px;
  padding-bottom: 1px;
  z-index: -1;
}

label[for="star5"] {
  position: relative;
  right: -3px;
  top: 1px;
}

label[for="star4"] {
  position: relative;
  right: -3px;
  top: 1px;
}

label[for="star3"] {
  position: relative;
  right: -2px;
  top: 1px;
}

label[for="star2"] {
  position: relative;
  right: -1px;
  top: 1px;
}

label[for="star1"] {
  position: relative;
  right: 0px;
  top: 1px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.3s ease;
}

.picked-rating p {
  padding: 0 5px;
  line-height: 0px;
}

.votedAlready,
.errorMessage {
  background-color: #fff;
  line-height: 20px !important;
}

.rate input:checked ~ label {
  color: #999;
}

.rate input:checked + label {
  color: #036;
  border-bottom-color: #036;
}
.rate input[type="radio"]:focus-visible + label {
  outline: -webkit-focus-ring-color auto 1px;
}

.rate input:hover + label {
  border-bottom-style: dotted;
}
.rate:hover input + label {
  color: #036;
}

.rate input:hover ~ label
.rate input[id="star0"] + label {
  color: #999;
}

.rate input:hover + label {
  color: #036;
}

.ratingWidget__content-container {
  display: flex;
  padding-bottom: 1.5rem;
}

article .picked-rating {
  top: 26px;
  padding-bottom: 0px;
  z-index: 1;
}

article .picked-rating p {
  position: relative;
  bottom: 5px;
}
article .ratingWidget__content-container {
  padding-bottom: 3rem;
}

@media screen and (max-width: 768px) {
  .flip-cardtext {
    top: 15px;
  }

  article .picked-rating,
  .picked-rating {
    top: 46px;
    padding-bottom: 0px;
    z-index: 1;
  }

  .average {
    width: 100%;
  }

  .flip-cardcontainer {
    width: 370px;
    margin-right: 0px;
    bottom:10px;
  }

  article .ratingWidget__content-container {
  padding-bottom: 2.5rem;
}

.flip-cardcontainer_averageRating {
  margin-top:10px;
}
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .flip-cardcontainer {
    width: 210px;
  }
  .ratingWidget__content-container {
    padding-bottom: 2rem;
  }
  article .ratingWidget__content-container {
    padding-bottom: 2.75rem;
  }

  article .picked-rating,
  .picked-rating {
    padding-bottom: 0px;
    z-index: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/app/components/ratings-widget-star.vue